import React, { useRef } from "react";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Link } from "react-router-dom";
import { Col, Row} from 'react-bootstrap'
import {Post} from '../../types/post';
import LinkTile from '../Card/BasicTiles/LinkTile';
import { bloggerPostList } from "../../types/bloggerServices";


gsap.registerPlugin(ScrollTrigger);

type LandingHeroProps = {
  posts: bloggerPostList[]
};

const LandingPostsSlider: React.FC<LandingHeroProps> = ({ posts}) => {
  const containerRef = useRef<HTMLParagraphElement | null>(null);
  const issue_cover='https://fatteh-media-files.s3.amazonaws.com/pages/magazine/cover1.webp';
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US');
  };

  /**
   * useGSAP(() => {
    const section = containerRef.current;
        if(section){
            const issue_cover = section.querySelectorAll(".issue-cover img");
            
            //freeze the text tile wraper and trigger text reveal
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: issue_cover,
                    start: 'top center',
                    end: '+=140%',
                    scrub: true,
                    markers: false,
                    pin: true,
                    anticipatePin: 1,
                },
            }).to(issue_cover,{ease: 'expo.in'})
            
        }

    }, []);
   */

  return (
        <Row className="scroll-slider" >
            <Col ref={containerRef} sm={12} md={12} lg={6} className="scroll-slider-text-wrapper">
                <div className='issue-cover'>
                  <img style={{width: "100%"}}  src={issue_cover} />
                </div>
            </Col>
            <Col className="scroll-slider-mobile">
              <h2 className='scroll-slider-text'>Recent Articles</h2>
              <div className='issue-cover'>
                  <img style={{width: "100%"}}  src={issue_cover} />
                </div>
            </Col>
            <Col className='scroll-slider-slide-wrapper' sm={12} md={12}lg={6}>
                {posts.slice(0,3).map((post, index) => (
                    <LinkTile 
                        item={{
                            image: post.images[0].url,
                            title: post.title,
                            subtitle: `By ${post.author.displayName}`,
                            description: formatDate(post.published)
                        }}
                        linkURL={`news/${post.id}`}
                        index={index}
                        classNames={'scroll-slider-slide'}
                    />
                    ))}
             </Col>
        </Row>
  );
};

export default LandingPostsSlider;
